import { render, staticRenderFns } from "./Bloco6NotasOrientativas.vue?vue&type=template&id=c054d76a&scoped=true&"
import script from "./Bloco6NotasOrientativas.vue?vue&type=script&lang=js&"
export * from "./Bloco6NotasOrientativas.vue?vue&type=script&lang=js&"
import style0 from "./Bloco6NotasOrientativas.vue?vue&type=style&index=0&id=c054d76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c054d76a",
  null
  
)

export default component.exports